/* Planet TRP — product page behaviour (sections/planet-product.liquid). Needs planet-core.js
   (window.TRP) for the cart drawer; without it, add-to-cart falls back to the native form post.
   Every element hook is guarded: a missing piece is a no-op. */
(function () {
  "use strict";
  document.querySelectorAll('[data-pp]').forEach(function (root) {
    var form = root.querySelector('.pp-form');
    var dataEl = root.querySelector('[data-pp-variants]');
    if (!form || !dataEl) return;
    var VARIANTS = []; try { VARIANTS = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name=id]');
    var addBtn = form.querySelector('.pp-add'), errEl = form.querySelector('.pp-err');
    var priceNow = root.querySelector('[data-pp-price] .now'), priceWas = root.querySelector('[data-pp-price] .was');
    var shipEl = root.querySelector('[data-pp-ship]');
    var sticky = root.querySelector('.pp-sticky'), stickyPrice = root.querySelector('[data-pp-sticky-price]'), stickyAdd = root.querySelector('.pp-sticky-add');
    var FREE_CENTS = +root.getAttribute('data-free-cents') || 0, FREE_RUPEES = Math.round(FREE_CENTS / 100);
    var fieldsets = [].slice.call(root.querySelectorAll('.pp-opt'));
    var current = VARIANTS.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || VARIANTS[0];

    /* --- variant selection: any number of options; only options with 2+ values have a fieldset --- */
    function chosen() {
      var sel = current ? current.options.slice() : [];
      fieldsets.forEach(function (fs) { var i = +fs.getAttribute('data-opt'), c = fs.querySelector('input:checked'); if (c) sel[i] = c.value; });
      return sel;
    }
    function match(sel) { return VARIANTS.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null; }
    /* a value is selectable only if SOME available variant has it together with the other current choices */
    function refreshValues() {
      var sel = chosen();
      fieldsets.forEach(function (fs) {
        var i = +fs.getAttribute('data-opt');
        fs.querySelectorAll('.pp-val').forEach(function (lab) {
          var input = lab.querySelector('input'), probe = sel.slice(); probe[i] = input.value;
          var v = match(probe), ok = !!(v && v.available);
          input.disabled = !ok; lab.classList.toggle('is-off', !ok);
          var pEl = lab.querySelector('.pp-val-p'); if (pEl) pEl.textContent = v ? v.now : '';
        });
      });
    }
    /* button state only — never touches the error line (render() clears it on a NEW selection) */
    function setButtons(v) {
      var ok = !!(v && v.available), label = !v ? 'Unavailable' : (ok ? 'Add to cart' : 'Sold out');
      if (addBtn) { addBtn.disabled = !ok; addBtn.textContent = label; }
      if (stickyAdd) { stickyAdd.disabled = !ok; stickyAdd.textContent = label; }
    }
    function render(v) {
      current = v;
      if (v) idInput.value = v.id;
      setButtons(v);
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (v) {
        if (priceNow) priceNow.textContent = v.now;
        if (priceWas) { priceWas.textContent = v.was || ''; priceWas.hidden = !v.was; }
        if (stickyPrice) stickyPrice.textContent = v.now;
        if (shipEl) shipEl.textContent = v.price > FREE_CENTS ? 'Free shipping — this pack qualifies on its own' : 'Free shipping on orders above ₹' + FREE_RUPEES;
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
    }
    root.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('.pp-opt')) return;
      var sel = chosen(), v = match(sel);
      /* a changed choice can leave the other options pointing at a sold-out / missing combination:
         fall back to the first available variant carrying the value just picked */
      if ((!v || !v.available) && e.target.checked) {
        var i = +e.target.closest('.pp-opt').getAttribute('data-opt');
        var alt = VARIANTS.filter(function (x) { return x.available && x.options[i] === e.target.value; })[0];
        if (alt) { v = alt; fieldsets.forEach(function (fs) { var k = +fs.getAttribute('data-opt'); fs.querySelectorAll('input').forEach(function (r) { r.checked = r.value === alt.options[k]; }); }); }
      }
      render(v); refreshValues();
    });
    refreshValues(); render(current);

    /* --- add to cart: Planet drawer via window.TRP; native form post if TRP is missing --- */
    var busy = false;
    function showErr(m) { if (errEl) { errEl.textContent = m; errEl.hidden = false; } if (window.TRP && TRP.toast) TRP.toast(m); }
    form.addEventListener('submit', function (e) {
      if (!window.TRP || !window.fetch) return;           // let the browser post the form
      e.preventDefault();
      if (busy || !current || !current.available) return;
      busy = true; if (errEl) { errEl.hidden = true; errEl.textContent = ''; } if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
      var RT = window.routes || {};
      fetch((RT.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { showErr((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.'); return; }
          return TRP.fetchCart().then(function () {
            var ic = document.getElementById('open-cart'); if (ic) { ic.classList.remove('bump'); void ic.offsetWidth; ic.classList.add('bump'); }
            TRP.openC(); if (TRP.beep) TRP.beep(720, .07);
          });
        })
        .catch(function () { showErr('Network error — please try again.'); })
        .then(function () { busy = false; setButtons(current); });
    });

    /* --- gallery: one active index drives the thumbnails, the mobile dots and the screen-reader line.
       Desktop (901px+, CSS stacks the images): page scroll decides which image is "in view"; a
       thumbnail scrolls the page to its image. Mobile: the strip scrolls sideways (swipe / arrow keys);
       a thumbnail scrolls the strip. The buy box is pinned with a top that lets a column taller than
       the window still scroll to its end. --- */
    var slides = root.querySelector('.pp-slides'), items = [].slice.call(root.querySelectorAll('.pp-slide'));
    var thumbs = [].slice.call(root.querySelectorAll('.pp-thumb')), dots = [].slice.call(root.querySelectorAll('.pp-dot'));
    var posEl = root.querySelector('[data-pp-pos]'), info = root.querySelector('.pp-info');
    var desk = window.matchMedia ? window.matchMedia('(min-width: 901px)') : { matches: false };
    var active = 0, HEAD = 96;
    function setActive(i, announce) {
      i = Math.max(0, Math.min(items.length - 1, i));
      if (i === active) return; active = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (posEl && announce) posEl.textContent = 'Image ' + (i + 1) + ' of ' + items.length;
      /* keep the active thumbnail visible inside its own row/rail without scrolling the page */
      var t = thumbs[i], rail = t && t.parentNode;
      if (rail) { if (desk.matches) { if (t.offsetTop < rail.scrollTop || t.offsetTop + t.offsetHeight > rail.scrollTop + rail.clientHeight) rail.scrollTop = t.offsetTop - 8; }
        else rail.scrollLeft = t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2; }
    }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i)); var el = items[i]; if (!el) return;
      if (desk.matches) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - HEAD, behavior: 'smooth' });
      else slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
      setActive(i, true);
    }
    /* desktop: the image whose area is most inside the window (below the header) is the active one */
    function fromPage() {
      var best = 0, bestVis = -1, vh = window.innerHeight;
      items.forEach(function (el, k) { var r = el.getBoundingClientRect(), vis = Math.min(r.bottom, vh) - Math.max(r.top, HEAD); if (vis > bestVis) { bestVis = vis; best = k; } });
      setActive(best, false);
    }
    function fromStrip() { setActive(Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)), true); }
    function pinInfo() {
      if (!info) return;
      /* sticky top: 96px when the column fits under the header; otherwise negative, so it scrolls
         with the page until its bottom is in view and pins there (nothing is ever hidden) */
      info.style.top = desk.matches ? Math.min(HEAD, window.innerHeight - info.offsetHeight - 24) + 'px' : '';
    }
    if (slides && items.length) {
      var raf = 0, sched = function (fn) { return function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(fn); }; };
      slides.addEventListener('scroll', sched(function () { if (!desk.matches) fromStrip(); }), { passive: true });
      window.addEventListener('scroll', sched(function () { if (desk.matches) fromPage(); }), { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-to')); }); });
      slides.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        if (desk.matches && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) return;   // leave page scrolling alone
        e.preventDefault(); go(active + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1));
      });
      var onMode = function () { pinInfo(); if (desk.matches) { slides.scrollLeft = 0; fromPage(); } else fromStrip(); };
      if (desk.addEventListener) desk.addEventListener('change', onMode); else if (desk.addListener) desk.addListener(onMode);
      window.addEventListener('resize', sched(pinInfo));
      window.addEventListener('load', pinInfo);
      if (window.ResizeObserver && info) new ResizeObserver(pinInfo).observe(info);   // variant change, FAQ, fonts
      onMode();
    }

    /* --- mobile sticky add-to-cart: appears once the main button has scrolled out of view --- */
    if (sticky && stickyAdd && addBtn && 'IntersectionObserver' in window) {
      stickyAdd.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
      new IntersectionObserver(function (es) {
        var gone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sticky.hidden = !gone; sticky.setAttribute('aria-hidden', gone ? 'false' : 'true'); stickyAdd.tabIndex = gone ? 0 : -1;
      }).observe(addBtn);
    }
  });
})();
